<template>
  <div>
    <el-input class="inputWidth" disabled v-model="address" placeholder="请输入内容"></el-input>
    <div ref="container" id="container" style="width:100%;height:100%;"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      address: "", // 用户选择的地址
      map: null,
      marker: null,
      longitude: "", // 经度
      dimension: "", // 维度
    };
  },
  mounted() {
    if (window.onload) {
      this.initMap();
    } else {
      window.addEventListener("load", () => {
        this.initMap();
        this.initMark();
      });
    }
  },
  methods: {
    // 初始化地图
    initMap() {
      const center = new TMap.LatLng(30.51586, 114.304252);
      this.map = new TMap.Map(document.getElementById("container"), {
        center: center, //设置地图中心点坐标
        zoom: 8, //设置地图缩放级别
        pitch: 0, //设置俯仰角
        rotation: 0, //设置地图旋转角度
      });
      this.map.on("click", this.doMap);
    },
    // 初始化mark
    initMark() {
      this.marker = new TMap.MultiMarker({
        map: this.map,
      });
    },
    // 点击地图
    doMap(evt) {
      console.log("点击地图：", evt);
      this.longitude = evt.latLng.lat;
      this.dimension = evt.latLng.lng;
      this.findPositionBylocation();
      this.removeMark();
      this.initMark();
      this.marker.add({
        position: evt.latLng,
      });
    },
    // 移除全部mark
    removeMark() {
      if (this.marker) {
        this.marker.setMap(null);
        this.marker = null;
      }
    },
    // 根据经纬度反查城市
    findPositionBylocation() {
      const KEY = "Y2HBZ-QAR33-3TW3V-Y6G6A-MB6U3-7CFA4";
      let url = "https://apis.map.qq.com/ws/geocoder/v1/";
      this.$jsonp(url, {
        key: KEY,
        location: this.longitude + "," + this.dimension,
        output: "jsonp",
      })
        .then((res) => {
          console.log(res);
          this.address = res.result.address
          // 通知父组件
          this.$emit('childrenSelectAddress',res.result.address)
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.mpContainer {
  width: 500px;
  height: 600px;
}
.inputWidth{
  width: 100%;
  padding-bottom: 20px;
  text-align: center;
}
</style>
